/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPayJunctionResponse
 */
export interface GetPayJunctionResponse {
    /**
     * 
     * @type {string}
     * @memberof GetPayJunctionResponse
     */
    publishableKey: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPayJunctionResponse
     */
    userName: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPayJunctionResponse
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPayJunctionResponse
     */
    configured?: boolean;
}

/**
 * Check if a given object implements the GetPayJunctionResponse interface.
 */
export function instanceOfGetPayJunctionResponse(value: object): value is GetPayJunctionResponse {
    if (!('publishableKey' in value) || value['publishableKey'] === undefined) return false;
    if (!('userName' in value) || value['userName'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function GetPayJunctionResponseFromJSON(json: any): GetPayJunctionResponse {
    return GetPayJunctionResponseFromJSONTyped(json, false);
}

export function GetPayJunctionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPayJunctionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'publishableKey': json['publishableKey'],
        'userName': json['userName'],
        'enabled': json['enabled'],
        'configured': json['configured'] == null ? undefined : json['configured'],
    };
}

export function GetPayJunctionResponseToJSON(json: any): GetPayJunctionResponse {
    return GetPayJunctionResponseToJSONTyped(json, false);
}

export function GetPayJunctionResponseToJSONTyped(value?: GetPayJunctionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'publishableKey': value['publishableKey'],
        'userName': value['userName'],
        'enabled': value['enabled'],
        'configured': value['configured'],
    };
}

